import React from 'react';
import axios from 'axios';

class Header extends React.Component {

    render() {
        return (

            <div className="col-md-12 no-sm-h-padding">
                <div className="row mt-2 mb-2 pb-1">
                    <div className="col-lg-12 col-md-12 col-sm-12" >
                        <div className="program-logo p0 "> 
                            {
                                typeof localStorage.programLogo !== undefined &&
                                <a>
                                    <img src={`data:image/jpeg;base64,${localStorage.programLogo}`} alt="logo" style={{width:'100%', height: 'auto'}}/>
                                </a>
                            }
                        </div>
                    </div>
                    
                </div>
            </div>
        );
    }
}

export default Header;